define('views/blocks/ProductBoostModalView',['jquery','backbone','underscore','app',
  'template!blocks/product/product-boost-modal'],

  function($, Backbone, _, app, ProductBoostModalTemplate) {
    var productBoostModel;
    var ProductBoostModalView = Backbone.View.extend({
      className: 'product-boost',
      overlay: 'transparent',
      events: {
        'click .product-boost__close':'cancel',
        'click .product-boost__cta':'useBoost',
      },
      initialize: function(model,initialSelection){
        var view = this;
        productBoostModel = model;
        view.render()
      },
      close: function() {
        this.trigger('close', this)
      },
      cancel:function(){
        this.trigger('cancel');
        this.close();
      },
      useBoost:function(){
        this.close();
        productBoostModel.applyBoostSelection();
        app.go('product',{product:productBoostModel.getTargetProduct()});
      },
      render: function() {
        this.$el.html(ProductBoostModalTemplate(productBoostModel))
      },
    })

    return ProductBoostModalView
  }
);
